<template>
  <Modal name="TRANSFER_CONFIRM_MODAL" :title="title" :width="600" actions>
    <template v-slot:body>
      <p>{{ $t('transfer.hint.wantToTransfer') }}</p>

      <v-data-table :items="selectedTransfers" :headers="transfersHeader" hide-default-footer disable-sort>
        <template v-slot:[`item.name`]="{ item }">
          <span class="d-block text-truncate body-2">
            {{ getNames(item) }}
          </span>
        </template>
        <template v-slot:[`item.type`]="{ item }">
          <span class="body-2">
            {{ receiverType(item) }}
          </span>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <span class="body-2">
            {{ total(item) }}
          </span>
        </template>
      </v-data-table>

      <v-divider />
    </template>

    <template v-slot:actions>
      <v-btn @click="closeAllModals" :disabled="isBeingTransfer" class="mr-5" large text>
        {{ $t('itemPrice.action.cancel') }}
      </v-btn>

      <v-btn @click="confirmTransfer" :loading="isBeingTransfer" color="primary" elevation="0" large dark>
        {{ $t('transfer.label.transferToSelected') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'

import { catalogMonetary } from '@/util/catalog'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'TransferConfirmModal',

  components: {
    Modal,
  },

  props: {
    parsedTransfers: {
      type: Array,
    },

    selectedTransfers: {
      type: Array,
    },

    refresh: {
      type: Function,
    },
  },

  computed: {
    ...mapGetters(['isBeingTransfer', 'wasTransferred']),
  },

  methods: {
    ...mapActions(['executeTransfers', 'retryTransfers']),
    ...mapMutations(['closeAllModals']),

    confirmTransfer() {
      if (typeof this.refresh === 'function') {
        this.retryTransfers(this.parsedTransfers).then(() => this.refresh())
      } else {
        this.executeTransfers(this.parsedTransfers).then(() => this.wasTransferred && this.$parent.resetSelected())
      }
    },

    getNames(item) {
      switch (item?.receiver_type) {
        case ('HOST'):
          return item?.host?.name
        case ('VENDOR'):
          return item?.vendor?.name
        case ('PARTNER'):
          return item?.partner?.name
        default:
          return '---'
      }
    },

    receiverType(item) {
      const receiverType = item?.receiver_type
      return receiverType ? this.$t(`transfer.receiverType.${receiverType}`) : '---'
    },

    total(item) {
      const total = item?.total
      return total ? catalogMonetary(total) : '---'
    },
  },

  data() {
    return {
      title: this.$t('transfer.label.confirmTransfer'),

      transfersHeader: [
        {
          text: this.$t('transfer.label.name'),
          value: 'name'
        },
        {
          text: this.$t('transfer.label.receiver'),
          value: 'type',
          width: 100,
        },
        {
          text: this.$t('charge.label.total'),
          value: 'total',
          width: 100,
          align: 'end',
        },
      ],
    }
  },
}
</script>
